import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling, withDebugTracing } from '@angular/router';
import { routes } from './app.routes';
import {
  MapPin, ChevronDown, ShoppingCart, Gift, Menu, X,
  Facebook, Twitter, Instagram, Youtube,
  Star, Clock, Tag, QrCode, Truck, Package, CreditCard,
  ChevronLeft, ChevronRight, ArrowLeft, Search, Plus, Minus, Leaf, Drumstick,
  Trash2, ShoppingBag, ChefHat, Award, Heart, Users, ArrowRight,
  Percent, Pizza, Utensils, Sparkles,
  Mail, Phone, Send, MessageCircle, HelpCircle
} from 'lucide-angular';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS, withFetch } from '@angular/common/http';
import { ApiFactoryEndPoints } from './common/api-factory-end-points';
import { AppConfigService } from './services/app-config.service';
import { LoaderInterceptor } from './common/loader-interceptor';
import { LoaderService } from './common/loader.service';
import { ToastrModule } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';

export function initializeApp(appConfig: AppConfigService) {
  return () => appConfig.loadConfig();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),

     provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      })
    ),
    AppConfigService,
        {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfigService],
      multi: true
    },
    ApiFactoryEndPoints,
    provideHttpClient(
      withInterceptorsFromDi(),
      withFetch() // 🔥 Use modern fetch API for better performance
    ),
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    LoaderService,
    provideAnimations(),
    // ✅ Toastr global module
    importProvidersFrom(
      ToastrModule.forRoot({
        timeOut: 3000,
        positionClass: 'toast-top-right',
        preventDuplicates: true,
        progressBar: true,
        progressAnimation: 'decreasing',
        easeTime: 300,
        maxOpened: 5,
        autoDismiss: true,
      }),
    ),
  ],
};
